import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import comp1 from "../assets/comp1.png";
import comp2 from "../assets/comp2.webp";
import comp3 from "../assets/comp3.png";
import comp4 from "../assets/comp4.png";
import comp5 from "../assets/comp5.png";
import "./Company.css";
import png4 from "../assets/png_4.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpLong } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";

export default function Company({ onContainChange }) {
  // State for the fetched ranking data
  const [rankingData, setRankingData] = useState({
    pourc1: 0,
    pourc2: 0,
    pourc3: 0,
    pourc4: 0,
    pourc5: 0,
  });

  // State for controlling the slide
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Slider data (with dynamic rank values)
  const sliderData = [
    { id: "5", image: comp5, alt: "@BPASanctuary", number: rankingData.pourc5, title: "Black Pine Animal Sanctuary", description: "A sanctuary for rescued exotic animals." },
    { id: "1", image: comp3, alt: "@ifawglobal", number: rankingData.pourc1, title: "Ifaw", description: "Ifaw focuses on animal welfare and conservation." },
    { id: "2", image: comp2, alt: "", number: rankingData.pourc2, title: "Animal Care", description: "Animal Care provides comprehensive care for all pets." },
    { id: "3", image: comp4, alt: "", number: rankingData.pourc3, title: "Place for Animals", description: "A safe haven for animals in need." },
    { id: "4", image: comp1, alt: "", number: rankingData.pourc4, title: "Animal Welfare", description: "Dedicated to promoting animal rights and welfare." },
  ];

  // Get the current slide data
  const currentSlide = sliderData[currentIndex];

  // Fetch ranking data from the API
  useEffect(() => {
    const fetchRankingData = async () => {
      try {
        const response = await axios.get(
          "https://zd5gpcqi.api.sanity.io/v2023-01-01//data/query/production?query=*[_type=='sanityObject']{pourc1, pourc2, pourc3, pourc4, pourc5}"
        );
        const data = response.data.result[0]; // Assuming you get the ranking data from the first object
        setRankingData({
          pourc1: data.pourc1 || 0,
          pourc2: data.pourc2 || 0,
          pourc3: data.pourc3 || 0,
          pourc4: data.pourc4 || 0,
          pourc5: data.pourc5 || 0,
        });
      } catch (error) {
        console.error("Error fetching ranking data:", error);
      }
    };

    fetchRankingData();
  }, []); // Empty array ensures this runs once on mount

  // Slide navigation
  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderData.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? sliderData.length - 1 : prevIndex - 1
    );
  };

  // Handle Company Click
  const handleCompanyClick = (company) => {
    setSelectedCompany(company); // Set the selected company and its description
    setShowModal(true); // Show the modal
    onContainChange(false);
  };

  const closeModal = () => {
    setShowModal(false);
    onContainChange(true); // Re-enable contain style
  };

  const openXWithMessage = () => {
    if (!selectedCompany) return;
    const tweetMessage = `Voting for ${selectedCompany.alt} helps provide shelter, care, and safety for animals in need. Join us in making a real difference for those who can’t speak for themselves. cinnamoroll.xyz
    https://x.com/sol_cinnamoroll/status/1868403321985552703?s=46 `;
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetMessage)}`;
    window.open(url, "_blank");
  };

  return (
    <section className="responsive-section">
      {/* Logo positioned top-right */}
      <div className="logo-top-right">
        <img src={png4} alt="Top Right Logo" className="logo-animation" />
      </div>

      {/* Title */}
      <div className="container mb-4">
        <h1 className="title" style={{ letterSpacing: "1.5px" }}>
          Support Animal Welfare with Cinnamoroll
        </h1>
        <p>
          We’re donating 40 SOL and 1% of our coin to support animal welfare! We’ve selected five incredible charities, and the choice is yours!
          Vote for your favorite, and the one with the highest votes will receive our donation. Let’s make a difference for animals!
        </p>
        <br />
      </div>
      <div className="slider-wrapper sli">
        <div className="slider-content">
          {/* Number above the Slide */}
            <div className="rank" onClick={() => handleCompanyClick(currentSlide)}>
              Rank: {currentSlide.number}%  
              <div className="icon-container">
                <FontAwesomeIcon className="hand-bounce" style={{fontSize: '30px'}} icon={faUpLong} />
              </div>
            </div>

          {/* Left Arrow */}
          <button onClick={prevSlide} className="arrow left">
            <i className="bi bi-arrow-left" style={iconStyle}></i>
          </button>

          <div className="company-info" style={{}}>
            <img
              src={currentSlide.image}
              alt={currentSlide.title}
              className="company-logo"
            />
          </div>

          {/* Right Arrow */}
          <button onClick={nextSlide} className="arrow right">
            <i className="bi bi-arrow-right" style={iconStyle}></i>
          </button>
        </div>
      
      </div>
      
      {/* Modal for Selected Company */}
      {showModal && selectedCompany && (
        <div className="modal-wrapper">
          {/* Background Overlay with Blur Effect */}
          <div
            className="modal-overlay"
            onClick={closeModal} // Close modal when clicking outside
          ></div>

          <div
            className="modal fade show"
            style={{ display: "block", borderRadius: "30px" }}
            aria-labelledby="companyModal"
            tabIndex="-1"
          >
            <div className="modal-dialog modal-dialog-centered popup">
              <div className="modal-content" style={{ backgroundColor: "#f9dbe7", border:"0px solid #f9dbe7", borderRadius:"20px"}}>
                <div className="modal-header" style={{ borderBottom: "1px solid #f9dbe7" }}>
                  <h5 className="modal-title" id="companyModal">{selectedCompany.title}</h5>
                  <button type="button" className="btn-close"  onClick={closeModal}></button>
                </div>
                <div className="modal-body text-center">
                  <img
                    src={selectedCompany.image}
                    alt={selectedCompany.title}
                    className="imgsel"
                  />
                  <p className="mt-1">{selectedCompany.description}</p>
                </div>
                <div className="modal-footer" style={{ marginBottom: "20px", marginTop: "0px" }}>
                  <button
                    type="button"
                    className="btn btn-lg"
                    style={{
                      backgroundColor: "#DF6C91",
                      margin: "auto",
                      borderRadius: "30px",
                    }}
                    onClick={openXWithMessage}
                  >
                    Help the animals at {selectedCompany.title}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

const iconStyle = {
  fontSize: "32px",
  color: "#000",
};
